import { motion } from "framer-motion"
import { useLayoutEffect, useRef, useState } from "react"
import { useHaptic } from "@/shared/hooks/use-haptic"
import { TRANSITION } from "@/shared/lib/motion"
import { TelegramMarkdown } from "@/shared/ui/telegram-markdown"

const COLLAPSED_HEIGHT = 320

export function PostDescription({ text }: { text: string }) {
	const bodyRef = useRef<HTMLDivElement>(null)
	const [fullHeight, setFullHeight] = useState<number | null>(null)
	const [isExpanded, setIsExpanded] = useState(false)
	const [wasToggled, setWasToggled] = useState(false)
	const { triggerHaptic } = useHaptic()

	useLayoutEffect(() => {
		const element = bodyRef.current
		if (!element) return
		const measure = () => setFullHeight(element.scrollHeight)
		measure()
		const observer = new ResizeObserver(measure)
		observer.observe(element)
		return () => observer.disconnect()
	}, [])

	const isClamped = fullHeight !== null && fullHeight > COLLAPSED_HEIGHT + 8
	const isCollapsed = isClamped && !isExpanded

	const toggle = () => {
		triggerHaptic("light")
		setWasToggled(true)
		setIsExpanded((value) => !value)
	}

	return (
		<section className="rounded-3xl bg-card p-4 ring-1 ring-white/10 sm:p-5">
			<motion.div
				initial={false}
				animate={{ height: isCollapsed ? COLLAPSED_HEIGHT : "auto" }}
				transition={wasToggled ? TRANSITION.base : { duration: 0 }}
				className="relative overflow-hidden"
			>
				<div ref={bodyRef} className="text-[15px] leading-relaxed whitespace-pre-wrap">
					<TelegramMarkdown>{text}</TelegramMarkdown>
				</div>
				<motion.span
					aria-hidden
					initial={false}
					animate={{ opacity: isCollapsed ? 1 : 0 }}
					transition={TRANSITION.base}
					className="pointer-events-none absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-card to-transparent"
				/>
			</motion.div>

			{isClamped && (
				<button
					type="button"
					onClick={toggle}
					className="mt-3 text-sm font-medium text-primary transition-opacity active:opacity-70"
				>
					{isExpanded ? "Свернуть" : "Показать полностью"}
				</button>
			)}
		</section>
	)
}
